import { QuickLink } from './QuickLink';

export const ContentWrapper = ({
  children,
  handleLinkClick,
  title,
  linkText,
}) => (
  <div className='base-comment-section'>
    <div className='base-comment-content'>
      <p className='comment-title'>{title}</p>
      <div className='pop-content'>{children}</div>
    </div>
    <QuickLink text={linkText} handleClick={handleLinkClick} />
  </div>
);
